import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

import { DashboardManagerBase } from './components/dashboard-manager-base/dashboard-manager-base';
import { Layout } from './components/layout/layout';
import { RouteErrorBoundary } from './components/route-boundary/route-boundary';
import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'reports/dashboards',
      errorElement: <RouteErrorBoundary />,
      element: (
        // TODO: Review usage of canAccessSelfServiceReporting combined with canViewAllTickets
        // We should avoid ANDing two capabilities in the frontend
        <LegacyCapabilitiesGuard capabilities={{ canViewAllTickets: true }}>
          <LegacyCapabilitiesGuard
            capabilities={{ canAccessSelfServiceReporting: true }}
          >
            <PagePlain>
              {/* 
                TODO: remove the div below after the migration to the new platform is complete.
                The div below takes all the styles like flex gaps,
                so the Layout doesn't change and looks like the old platform.
                Once we're fully migrated to the new platform, this div can be removed.
            */}
              <div>
                <Layout />
              </div>
            </PagePlain>
          </LegacyCapabilitiesGuard>
        </LegacyCapabilitiesGuard>
      ),
      children: [
        {
          index: true,
          lazy: () =>
            import('./pages/dashboard-management/dashboard-management.page'),
        },
        {
          element: <DashboardManagerBase />,
          children: [
            {
              path: 'new',
              lazy: () => import('./pages/insights-edit/insights-new.page'),
            },
            {
              path: ':dashboardId',
              children: [
                {
                  index: true,
                  lazy: () => import('./pages/dashboard/insights.page'),
                },
                {
                  path: 'edit',
                  lazy: () =>
                    import('./pages/insights-edit/insights-edit.page'),
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  navigation: ({ legacyCapabilities }) => {
    // TODO: Review usage of canAccessSelfServiceReporting combined with canViewAllTickets
    // We should avoid ANDing two capabilities in the frontend
    const hasDashboardsAccess =
      legacyCapabilities?.canViewAllTickets &&
      legacyCapabilities?.canAccessSelfServiceReporting;

    if (!hasDashboardsAccess) return {};

    return {
      reporting: {
        dashboardManagement: {
          title: i18n.t('insights:menu.dashboards'),
          segment: '/reports/dashboards',
        },
      },
    };
  },
  whatsNew: () => {
    return [];
  },
} satisfies FeatureConfig;
